import { Component, OnInit } from '@angular/core'
import { environment } from '@se-po/shared-environments'

const INBOX_ELEMENT_NAME = 'se-inbox-element'
const INBOX_SCRIPT_NAMES = ['runtime', 'polyfills', 'element']

@Component({
  selector: 'app-messages-new-page',
  templateUrl: './messages-new-page.component.html',
  standalone: false
})
export class MessagesNewPageComponent implements OnInit {
  private static loadPromise: Promise<void>

  public ngOnInit(): void {
    if (customElements.get(INBOX_ELEMENT_NAME)) return

    MessagesNewPageComponent.loadPromise = MessagesNewPageComponent.loadPromise || this.loadInboxElement()
  }

  private async loadInboxElement(): Promise<void> {
    for (const scriptName of INBOX_SCRIPT_NAMES) {
      await this.loadScript(`${environment.baseUrl}/se-inbox/${scriptName}.js`)
    }
  }

  private loadScript(src: string): Promise<void> {
    if (document.querySelector(`script[src="${src}"]`)) return Promise.resolve()

    return new Promise((resolve, reject) => {
      const script = document.createElement('script')
      script.async = false
      script.src = src
      script.type = 'module'
      script.onload = () => resolve()
      script.onerror = () => reject()
      document.body.appendChild(script)
    })
  }
}
